<template>
  <div class="preview" v-if="isShow">
    <div class="entery_title">
      <div class="line"></div>
      <div class="base_title">预览</div>
      <div class="fuwenben">（鼠标在手机区域内滚动可下滑更多内容）</div>
    </div>

    <div class="preview_phone">
      <img src="../../../assets/img/web/yulan.png" />
      <div class="preview_phone_content">
        <el-scrollbar style="height:762px">
          <!-- <el-carousel height="150px"> -->
          <!-- <el-carousel-item v-for="(item, index) in urlList" :key="index"> -->
          <div class="imgbox">
            <!-- <img class="preview_phone_content_img" src="../../../assets/img/web/001.png" alt /> -->
            <img class="threeDIcon" :src="imageList[0]" alt />
            <div class="numbi">1/5</div>
            <img class="share" src="../../../assets/img/web/fenxiang-.png" />
          </div>
          <!-- </el-carousel-item> -->
          <!-- </el-carousel> -->

          <div class="goodInfo">
            <div class="goodInfo_title">{{ruleForm.name}}</div>
            <div class="goodInfo_money">￥{{ruleForm.custRetail}}</div>
          </div>

          <div class="area">
            <div class="area_left">
              <div style="color:#999999">送至</div>
              <div style="color:#333333">湖北省武汉市洪山区关东街道</div>
            </div>
            <img src="../../../assets/img/web/iconright.png" class="area_right" alt />
          </div>

          <div class="introduction">
            <div class="introduction_item">商品介绍</div>
            <div class="introduction_item">参考规格</div>
          </div>
          <div class="imgList">
            <!-- <div class="imgList_item" v-for="(item, index) in 5 " :key="index">
              <img :src="item" alt />
            </div> -->
            <div class="imgList_item"  v-for="(item, index) in imgList " :key="index">
              <img :src="item" alt />
            </div>
            
            <div class="footer">
              <div class="footer_left">
                <img class="footer_left_img" src="../../../assets/img/web/fangzi.png" alt />
                <div>3D商城</div>
              </div>
              <div class="footer_right">立即购买</div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../../../components/commonComponents/bus";
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    ruleForm:{
      type:Object,
      default:()=>{}
    },
    threeD:{
      type:Object,
      default:()=>{}
    },
    imageList:{
      type:Array,
      default:()=>[]
    }
  },
  watch: {
    list: {
      handler: function(old, news) {},
      deep: true
    },
    ruleForm: {
      handler: function(old, news) {},
      deep: true
    },
    threeD: {
      handler: function(old, news) {},
      deep: true
    },


  },
  data() {
    return {
      isShow: false,
      imgList: this.list
    };
  },
  created() {
    bus.$on("imgList", msg => {
      this.imgList = msg;
    });
    console.log('2222',this.threeD);
    
  }
};
</script>

<style lang='less' scoped>
.preview_phone {
  height: 863px;
  width: 431px;
  border-radius: 64px;
  position: relative;
}
.footer {
  height: 50px;
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  background-color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer_left {
  text-align: center;
}
.footer_left_img {
  height: 15px;
  width: 15px;
}
.footer_right {
  width: 190px;
  height: 40px;
  background: rgba(109, 81, 51, 1);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-left: 50px;
}
.imgList {
  padding-bottom: 100px;
  position: relative;
}
.imgList_item {
  width: 100%;
  margin-bottom: 10px;
}

.introduction {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #fff;
}
.introduction_item {
  height: 20px;
  font-size: 16px;
  color: #333333;
  padding-bottom: 8px;
}
.introduction_item:nth-child(1) {
  border-bottom: 3px solid #6d5133;
  font-weight: 700;
}
.area {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  background-color: #fff;
}
.area_left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 270px;
  height: 16px;
  font-size: 16px;
  color: rgba(153, 153, 153, 1);
  line-height: 24px;
}
.area_right {
  width: 7px;
  height: 12px;
}
.goodInfo {
  height: 115px;
  background-color: #fff;
  padding: 20px 32px 0 15px;
  margin-bottom: 10px;
}
.goodInfo_title {
  height: 41px;
  font-size: 16px;
  color: rgba(22, 22, 22, 1);
  line-height: 25px;
  margin-bottom: 15px;
  color: #161616;
}
.goodInfo_money {
  height: 15px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(140, 117, 83, 1);
  line-height: 24px;
}
.preview_phone_content {
  position: absolute;
  bottom: 25px;
  height: 720px;
  overflow: hidden;
  width: 374px;
  right: 28px;
  background-color: #f5f5f5;
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
}
.imgbox {
  position: relative;
}
.preview_phone_content_img {
  height: 403px;
  width: 192px;
  padding: 25px 91px 22px 91px;
  background-color: #efefef;
  position: relative;
}
.threeDIcon {
  // position: absolute;
  // bottom: 15px;
  // left: 158px;
  height: 450px;
  // width: ;
}
.numbi {
  width: 40px;
  height: 20px;
  background: rgba(22, 22, 22, 1);
  opacity: 0.7;
  border-radius: 10px;
  position: absolute;
  bottom: 15px;
  right: 15px;
  text-align: center;
  line-height: 20px;
  color: #fff;
}
.share {
  position: absolute;
  top: 15px;
  right: 15px;
  height: 20px;
  width: 20px;
}

::v-deep.el-scrollbar__wrap {
  overflow-x: hidden;
}

.entery_title {
  display: flex;
  margin-top: 30px;
  align-items: center;
  margin-bottom: 20px;
  .line {
    width: 3px;
    height: 19px;
    margin-right: 5px;
    background: rgba(102, 102, 102, 1);
  }
  .base_title {
    font-size: 18px;
    font-weight: bold;
    margin-right: 5px;
    color: rgba(51, 51, 51, 1);
  }
  .fuwenben {
    font-size: 14px;
    font-weight: 400;
    color: rgba(245, 108, 108, 1);
  }
}
</style>